import CoreJoystick from "@/prefabs/core/Joystick";
import CoreJoystickButton from "../core/JoystickButton";
import UtilsScreen from "@/lib/utils/screen";
var AttackButton = /** @class */ (function () {
    function AttackButton(scene) {
    }
    return AttackButton;
}());
var CustomControls = /** @class */ (function () {
    function CustomControls(scene) {
        this.scene = scene;
        if (this.scene.sys.game.device.os.desktop)
            return;
        this.joystick = new CoreJoystick(this.scene, 0, 0, {
            base: { width: 300, height: 300 },
            radius: 320,
            thumb: { width: 240, height: 240 },
        });
        this.attack = new CoreJoystickButton(this.scene, 0, 0, {
            base: { width: 300, height: 300 },
            thumb: { width: 240, height: 240 },
        });
    }
    CustomControls.prototype.setOnAttack = function (listener) {
        if (this.scene.sys.game.device.os.desktop)
            return;
        this.attack.onclick = listener;
    };
    CustomControls.prototype.setOnMove = function (listener) {
        if (this.scene.sys.game.device.os.desktop)
            return;
        this.joystick.onMove(listener);
    };
    CustomControls.prototype.setVisible = function (visible) {
        if (this.scene.sys.game.device.os.desktop)
            return;
        this.joystick.setVisible(visible);
        this.attack.setVisible(visible);
    };
    CustomControls.prototype.resize = function (_width, _height) {
        if (!this.joystick || !this.attack)
            return;
        var joystick_s_x = Math.min(_width * 0.25, 300) / 300;
        var joystick_s_y = Math.min(_height * 0.25, 300) / 300;
        var joystick_s = Math.min(Math.min(joystick_s_x, joystick_s_y), 1);
        var attack_s_x = Math.min(_width * 0.25, 300) / 300;
        var attack_s_y = Math.min(_height * 0.25, 300) / 300;
        var attack_s = Math.min(Math.min(attack_s_x, attack_s_y), 1);
        this.joystick.setScale(joystick_s);
        this.attack.setScale(attack_s, attack_s, true);
        var _a = UtilsScreen.safe_area(this.scene), x_min = _a.x_min, x_max = _a.x_max, y_max = _a.y_max, width = _a.width, height = _a.height;
        var pos_y = (y_max + height / 2) / 2;
        var pos_joystick_x = (width / 2 + x_min) / 2;
        var pos_attack_x = (x_max + width / 2) / 2;
        this.joystick.setPosition(pos_joystick_x, pos_y);
        this.attack.setPosition(pos_attack_x, pos_y);
    };
    return CustomControls;
}());
export default CustomControls;
